export const messageTemplates = ({ name, platform, issueId, countryId }) => {
  const appStore = platform === 'ios' ? 'App Store' : 'Play Store';

  const supportEmail = countryId === 1 ? 'contato@umatch.com.br' : 'help@umatch.app';

  const language = countryId === 1 ? 'pt-BR' : 'en-US';

  const greeting =
    language === 'pt-BR'
      ? `Olá, ${name}! Tudo bem?

Referente ao ticket ${issueId}:`
      : `Hello, ${name}! How are you?

Following the ticket ${issueId}:`;

  const wrapMessage = message => `${greeting}\n\n${message}`;

  return language === 'pt-BR'
    ? {
        payment: [
          {
            id: 'defaultApproved',
            name: 'Default - Aprovado',
            message: wrapMessage(
              `Nós resolvemos o problema relatado. Se você acredita que o problema persiste, por favor envie um novo relato ou nos informe em ${supportEmail}`
            ),
          },
          {
            id: 'defaultRejected',
            name: 'Default - Recusado',
            message: wrapMessage(
              `Recebemos seu relato de problema de pagamento e estamos trabalhando nele. Se você sentir que isso é uma questão urgente, não hesite em entrar em contato conosco em ${supportEmail}`
            ),
          },
          {
            name: 'Cancelamento de assinatura',
            message:
              wrapMessage(`O cancelamento deve ser feito diretamente com a ${appStore}, pois eles são responsáveis pelo processamento de pagamentos e assinaturas.

Caso tenha problemas ao realizar o cancelamento, por favor, entre em contato com o suporte da ${appStore} para que eles possam te ajudar.`),
          },
          {
            name: 'Reembolso/Estorno',
            message: wrapMessage(
              `Para solicitar um reembolso, você deve entrar em contato diretamente com o suporte da ${appStore}, pois eles são responsáveis pelo processamento de compras.

Caso tenha outras dúvidas ou problemas, envie um e-mail para ${supportEmail} para que possamos te ajudar.`
            ),
          },
          {
            name: 'Renovação automática + cancelamento',
            message: wrapMessage(
              `Os planos Premium e Plus são vendidos no modelo de assinatura e se renovam automaticamente a não ser que você cancele a assinatura. Esse modelo de cobrança é padrão das lojas de aplicativo para assinaturas.

O cancelamento deve ser feito diretamente com a ${appStore}, pois eles são responsáveis pelo processamento de pagamentos e assinaturas.

Caso tenha problemas ao realizar o cancelamento, por favor, entre em contato com o suporte da ${appStore} para que eles possam te ajudar.`
            ),
          },
          {
            name: 'Restaurar compras',
            message: wrapMessage(
              `Não fomos informados da sua compra pela ${appStore}.

Para tentar corrigir esse problema, tente restaurar suas compras. Para isso, você deve acessar a tela de configurações (no canto superior direito, dentro da aba de perfil no aplicativo) e clicar no botão "Restaurar compras".

Caso o problema persista, por favor, entre em contato no e-mail ${supportEmail} com o número do ticket (${issueId}) e um comprovante de pagamento para que possamos te ajudar.`
            ),
          },
          {
            name: 'Compra não recebida - resolvido',
            message: wrapMessage(
              `Adicionamos o conteúdo à sua conta. Por favor, verifique se ele está disponível para você.`
            ),
          },
          {
            name: 'Compra não recebida - não resolvido',
            message: wrapMessage(
              `Por favor, entre em contato no e-mail ${supportEmail} com um comprovante de pagamento e informando qual o item comprado para que possamos te ajudar a resolver esse problema.`
            ),
          },
          {
            name: 'Pagar no débito/PIX',
            message: wrapMessage(
              `No momento, só aceitamos pagamentos via cartão de crédito. Essa forma de cobrança é padrão das lojas de aplicativo para assinaturas.

Caso tenha alguma dúvida ou problema, entre em contato conosco em ${supportEmail}`
            ),
          },
          {
            name: 'Cobrança em parcela única',
            message:
              wrapMessage(`Os planos Semestral e Anual são cobrados em parcela única. Você pode verificar o valor total da compra no botão de confirmação e no modal de confirmação da ${appStore} antes de finalizar o pagamento.

Caso deseje solicitar um reembolso, entre em contato diretamente com a ${appStore} para que eles possam te ajudar.

Caso tenha outras dúvidas ou problemas, envie um e-mail para ${supportEmail}.`),
          },
          {
            name: 'Pagamento duplicado',
            message: wrapMessage(
              `Para solicitar o reembolso de um pagamento duplicado, você deve entrar em contato diretamente com a ${appStore}, pois eles são responsáveis pelo processamento de pagamentos e assinaturas.`
            ),
          },
          {
            name: 'Não consigo finalizar a compra',
            message: wrapMessage(
              `Se você está enfrentando problemas para finalizar a compra, por favor, entre em contato com o suporte da ${appStore} para que eles possam te ajudar.

Caso tenha outras dúvidas ou problemas, envie um e-mail para ${supportEmail}.`
            ),
          },
        ],
        bug: [
          {
            id: 'defaultApproved',
            name: `Default - Aprovado`,
            message: wrapMessage(
              `Nós resolvemos o problema que você relatou. Se você acredita que o problema persiste, por favor entre em contato no e-mail ${supportEmail}`
            ),
          },
          {
            id: 'defaultRejected',
            name: `Default - Recusado`,
            message:
              wrapMessage(`Recebemos seu relato de erro e estamos trabalhando nele. Se você achar que isso é uma questão urgente, não hesite em entrar em contato conosco em ${supportEmail}

Obrigado por nos ajudar a melhorar a Umatch!`),
          },
          {
            name: 'Temp: Altura',
            message: wrapMessage(`Já resolvemos o problema de selecionar altura!

Por favor, atualize o aplicativo para a versão mais recente na ${appStore}.

Caso tenha outras dúvidas ou questões, envie um e-mail para ${supportEmail}.`),
          },
          {
            name: 'Solicitar evidências',
            message: wrapMessage(
              `Para nos ajudar a resolver o problema que você está enfrentando, precisamos de mais informações.

Por favor, envie um vídeo ou captura de tela do erro que você está vendo para o e-mail ${supportEmail}`
            ),
          },
        ],
        'info change': [
          {
            id: 'defaultApproved',
            name: 'Default - Aprovado',
            message: wrapMessage(`Seu pedido de alteração de informação foi aprovado.

Caso possamos ajudar com mais algo, não hesite em enviar um novo pedido ou entrar em contato conosco em ${supportEmail}`),
          },
          {
            id: 'defaultRejected',
            name: 'Default - Recusado',
            message: wrapMessage(`Seu pedido de alteração de informação foi rejeitado.

Se você tem alguma dúvida ou precisa de mais assistência, entre em contato conosco em ${supportEmail}`),
          },
        ],
      }
    : {
        payment: [
          {
            id: 'defaultApproved',
            name: 'Default - Approved',
            message: wrapMessage(
              `We have resolved the issue you reported. If you believe the issue persists, please submit a new report or inform us at ${supportEmail}.`
            ),
          },
          {
            id: 'defaultRejected',
            name: 'Default - Rejected',
            message: wrapMessage(
              `We have received your payment issue report and are working on it. If you feel this is an urgent matter, do not hesitate to contact us at ${supportEmail}.`
            ),
          },
          {
            name: 'Subscription cancellation',
            message:
              wrapMessage(`The cancellation must be done directly with the ${appStore}, as they are responsible for payment and subscription processing.

If you have trouble canceling, please contact ${appStore} support so they can help you.`),
          },
          {
            name: 'Auto-renewal + cancellation',
            message: wrapMessage(
              `The Plus and Premium plans are sold on a subscription model and renew automatically unless you cancel the subscription.

The cancellation must be done directly with the ${appStore}, as they are responsible for payment and subscription processing.

If you have trouble canceling, please contact ${appStore} support so they can help you.`
            ),
          },
          {
            name: 'Duplicate payment',
            message: wrapMessage(
              `To request a refund for a duplicate payment, you must contact the ${appStore} directly, as they are responsible for payment and subscription processing.`
            ),
          },
          {
            name: 'Refund/Chargeback',
            message: wrapMessage(
              `To request a refund, you must contact the ${appStore} directly, as they are responsible for purchase processing.`
            ),
          },
          {
            name: 'Purchase not received - resolved',
            message: wrapMessage(`We have added the content to your account. Please check if it is available to you.`),
          },
          {
            name: 'Purchase not received - unresolved',
            message: wrapMessage(
              `Please contact us at ${supportEmail} with a proof of payment and informing which item you bought so we can help you resolve this issue.`
            ),
          },
          {
            name: 'Pay with debit/PIX',
            message: wrapMessage(
              `At the moment, we only accept payments via credit card. This billing method is standard for app stores for subscriptions. If you have any questions or problems, contact us at ${supportEmail}.`
            ),
          },
          {
            name: 'Single installment charge',
            message: wrapMessage(
              `The Semiannual and Annual plans are charged in a single installment. You can check the total purchase amount on the confirmation button and on the ${appStore} confirmation modal before finalizing the payment. If you wish to request a refund, contact ${appStore} directly so they can help you. If you have any other questions or problems, send an email to ${supportEmail}.`
            ),
          },
          {
            name: "Can't complete purchase",
            message: wrapMessage(
              `If you are having trouble completing the purchase, please contact ${appStore} support so they can help you. If you have any other questions or problems, send an email to ${supportEmail}.`
            ),
          },
          {
            name: 'Restore purchases',
            message: wrapMessage(
              `We were not informed of your purchase by the ${appStore}.

To try to fix this problem, try restoring your purchases. To do this, you must access the settings screen (Within the profile tab in the app, in the upper right corner) and click on the "Restore purchases" button.

If the problem persists, please contact us at ${supportEmail} with the ticket number (${issueId}) and a proof of payment so we can help you.`
            ),
          },
        ],
        bug: [
          {
            id: 'defaultApproved',
            name: `Default - Approved`,
            message: wrapMessage(
              `We have resolved the issue you reported. If you believe the issue persists, please contact us at ${supportEmail}`
            ),
          },
          {
            id: 'defaultRejected',
            name: `Default - Rejected`,
            message: wrapMessage(
              `We have received your bug report and are working on it. If you feel this is an urgent matter, do not hesitate to contact us at ${supportEmail}.`
            ),
          },
          {
            name: 'Request evidence',
            message: wrapMessage(
              `To help us resolve the issue you are facing, we need more information. Please send a video or screenshot of the error you are seeing to ${supportEmail}.`
            ),
          },
          {
            name: 'Temp: Height',
            message: wrapMessage(
              `We have already resolved the issue of selecting height! Please update the app to the latest version on the ${appStore}. If you have any other questions or concerns, send an email to ${supportEmail}.`
            ),
          },
        ],
        'info change': [
          {
            id: 'defaultApproved',
            name: 'Default - Approved',
            message: wrapMessage(`Your information change request has been approved.

If we can help with anything else, do not hesitate to submit a new request or contact us at ${supportEmail}.`),
          },
          {
            id: 'defaultRejected',
            name: 'Default - Rejected',
            message: wrapMessage(`Your information change request has been rejected.

If you have any questions or need further assistance, please contact us at ${supportEmail}.`),
          },
        ],
      };
};
